export default "__VITE_ASSET__D6u0PfW9__"